import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useStyles } from '../styles';
import { Grid, FormHelperText, Button, Typography, Box, IconButton, Autocomplete, Alert } from '@mui/material';
import TextField from '@mui/material/TextField';
import { ISelect } from '../../../models/Roles/RolesContracts';
import {
  POLICY_ACTIONS_LABEL,
  POLICY_NAME_LABEL,
  POLICY_DESC_LABEL,
  ADD_ATTRIBUTE_BTN_TEXT,
  ENTITY_ATTRIBUTE_TITLE,
  DISPLAY_NAME,
  POLICY_NAME,
  POLICY_DESCRIPTION,
  POLICY_ENTITY_ACTION,
  ENTITY_DATA_TITLE,
  ENTITY_TITLE,
  POLICY_RESOURCE_ACTION,
  POLICY_NAMESPACE_ACTION,
  DATA_PLATFORM_NAMESPACE,
  SELECT_ALL,
  NO_RECORDS_IN_SEARCH,
  POLICY_RESOURCE_LABEL,
  NAMESPACE_LABEL
} from '../constants';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { useDispatch, useSelector } from 'react-redux';
import {
  getEntitiesFormError,
  selectedPolicyEntitiesFormData,
  getAttributes,
  getAttributesFormError,
  getResourceNSSelector,
  getResourcesSelector,
  getDPModelSelector,
  getColumnAttributes,
  getColumnAttributesFormError,
  getResourcePaginationSelector,
} from '../../../store/role/policyEntity/entitySelector';
import {
  addAttribute,
  addColumnAttribute,
  resetEntityPolicyAttributes,
  setAttributeFormErrorData,
  setColumnAttributeFormErrorData,
  setPolicyEntitiesFormData,
  setResources,
  updateEntityFormError
} from '../../../store/role/policyEntity/entityActionCreator';
import {
  getDPModel,
  getResourceNS,
  getResources,
  getEntitiesAttributes,
  getDPEntitiesAttributes
} from '../../../store/role/policyEntity/entities';
import { getResourceTypeById } from '../../../services/policy';
import { selectError } from '../../../store/error/errorSelector';
import Attribute from './Attribute';
import { compareByProperty } from '../../../utility/commonUtility';
import ColumnAttribute from './ColumnAttributes';
import { IEntityNameSpace, IEnityResources, IAction } from '../../../models/Policies/PolicyContract';
import _ from 'lodash';
import LuiMultiSelectCustom from '../../../shared/LuiMultiSelectCustom';
import CustomSearchList from '../../customSearchList/CustomSearchList';
import { ArrowTrendDownFill, ArrowTrendUpFill, Info } from '@jda/lui-common-icon-library-mui5';

const defaultNameSpace = {
  id: 0,
  moduleId: 0,
  name: '',
  displayName: '',
  childrens: []
};

const defaultResource = {
  displayName: '',
}
const defaultChildNodeData = {
  actions: [],
  description: '',
  displayName: '',
  id: 0,
  name: '',
  namespaceId: 0,
  owner: null,
  realmId: null,
  typeId: null,
};

const Entities = (props: any) => {
  const { edit, rowData } = props;
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const policyEntitiesFormData = useSelector(selectedPolicyEntitiesFormData);
  const formErrorState = useSelector(getEntitiesFormError);
  const { version } = useSelector(getDPModelSelector);
  const resourceNS = useSelector(getResourceNSSelector);
  const resources = useSelector(getResourcesSelector);
  const pagination = useSelector(getResourcePaginationSelector);
  const attributes = useSelector(getAttributes);
  const attributesFormError = useSelector(getAttributesFormError);
  const columnAttributes = useSelector(getColumnAttributes);
  const columnAttributesFormError = useSelector(getColumnAttributesFormError);
  const [treeData, setTreeData] = useState<Array<IEntityNameSpace>>([]);
  const [childNodeData, setChildNodeData] = useState<any>(defaultChildNodeData);
  const [selectedNameSpace, setSelectedNameSpace] = useState<IEntityNameSpace>(defaultNameSpace);
  const [namespaceVal, setNamespaceVal] = useState<string>('');
  const [resourceAction, setResourceAction] = useState([]);
  const [selectedResource, setSelectedResource] = useState(defaultResource);
  const errors = useSelector(selectError);
  const [openSearchResource, setOpenSearchResource] = useState(false);
  const [searchString, setSearchString] = useState('');
  const textFieldRef = useRef<HTMLInputElement>(null);
  const ignoreBlurRef = useRef(false);

  const getAllResourcesList = async () => {
    const resourcePayload = {
      pageNo: 1,
      searchString: '',
      namespaceId: selectedNameSpace?.id,
      pageSize: 50,
    }
    getResources(resourcePayload, dispatch);
  }

  useEffect(() => {
    if (selectedNameSpace !== defaultNameSpace && selectedNameSpace.id !== 0) {
      setSelectedResource(defaultResource);
      setSearchString('');
      getAllResourcesList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNameSpace]);

  const handleGoToTheNextPage = useCallback(async (pageNo: number) => {
    if (pageNo !== pagination.pageNumber) {
      const resourcePayload = {
        pageNo: pageNo,
        searchString: searchString,
        namespaceId: selectedNameSpace?.id,
        pageSize: 50,
      }
      await getResources(resourcePayload, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNameSpace, pagination, searchString])

  const onSearchResource = (searchValue: string) => {
    if (selectedNameSpace !== defaultNameSpace) {
      const resourcePayload = {
        pageNo: 1,
        searchString: searchValue,
        namespaceId: selectedNameSpace?.id,
        pageSize: 50,
      }
      if (searchValue.trim() !== "" && searchValue.length > 3) {
        getResources(resourcePayload, dispatch);
      }
      if (!searchValue.trim().length) {
        getAllResourcesList();
      }
    }
  }

  const debounceFn = useCallback(
    _.debounce(onSearchResource, 500), 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedNameSpace]);

  const handleChange = (e: any) => {
    setSearchString(e.target.value);
    debounceFn(e.target.value);
  };

  const onSelectResource = (value?: any) => {
    ignoreBlurRef.current = true;
    setSelectedResource(value);
    getAllResourcesList();
    handleItemClick(`${selectedNameSpace.displayName}.${value.displayName}`, value);
    setSearchString(value.displayName)
    setOpenSearchResource(false);
    setTimeout(() => {
      ignoreBlurRef.current = false;
    }, 0);
  }

  const handleClose = () => {
    if (ignoreBlurRef.current) return;
    if (selectedResource !== defaultResource && (selectedResource.displayName !== searchString) && !edit) {
      onSelectResource(selectedResource)
    }
    else if (searchString && (selectedResource.displayName !== searchString) && !edit) {
      setSearchString('')
      getAllResourcesList();
      setOpenSearchResource(false);
    }
    else {
      setOpenSearchResource(false);
    }
  };

  const handleToggleSearch = () => {
    if (!openSearchResource && textFieldRef.current) {
      textFieldRef.current.focus();
    }
    setOpenSearchResource(!openSearchResource);
  };

  useEffect(() => {
    getResourceNS(dispatch);
  }, [dispatch]);

  useEffect(() => {
    onEditEntityPolicySetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit, resourceNS]);

  useEffect(() => {
    if (edit && resourceAction.length) {
      handleEntityAttributes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childNodeData]);

  useEffect(() => {
    if (resources?.length > 0) {
      setTreeData(prev =>
        prev.map(node => {
          if (node.id === selectedNameSpace?.id) {
            return {
              ...node,
              childrens: resources.filter((item: IEnityResources) => item.namespaceId === selectedNameSpace?.id)
            };
          }
          return node;
        })
      );
    } else {
      setTreeData(resourceNS);
    }
    if (edit && namespaceVal === '') {
      dispatch(resetEntityPolicyAttributes());
      const expression = JSON.parse(rowData.expression);
      const namespaceName = resourceNS.filter((item: IEnityResources) => item.name === expression?.namespace);
      onSearchResource(expression?.resource?.name);
      const resourceName = resources.filter((item: IEnityResources) => item.name === expression?.resource?.name);
      if ((namespaceName && namespaceName.length) && (resourceName && resourceName.length)) {
        const selectedEntityNameSpace = namespaceName[0]?.displayName + "." + resourceName[0]?.displayName;
        setNamespaceVal(selectedEntityNameSpace);
        const selectedActionList = expression?.resource?.policies?.entitySecurity?.actions;
        const newSelectedActionList: any = [];
        setSelectedResource(resourceName[0]);
        setSearchString(resourceName[0]?.displayName);
        getAllResourcesList();
        handleItemClick(selectedEntityNameSpace, resourceName[0]);
        // getting action list and setting selected actions with id, displayName, name format
        resourceName[0]?.actions.forEach(({ displayName, id, name }: IAction) => {
          if (selectedActionList && selectedActionList.length) {
            selectedActionList.forEach((actionName: string) => {
              if (actionName === name) newSelectedActionList.push({ key: id, displayName, name });
            })
          }
        });
        dispatch(setPolicyEntitiesFormData(POLICY_ENTITY_ACTION, newSelectedActionList || []));
        // setting attributes and data permissions
        const attributePermissionArray = expression?.resource?.policies?.attributeSecurity;
        const dataPermissionArray = expression?.resource?.policies?.dataSecurity;
        if (attributePermissionArray && attributePermissionArray.length) {
          attributePermissionArray.forEach((attribute: any) => {
            const attributeActionList: any = [];
            if (attribute) {
              resourceName[0]?.actions.forEach(({ displayName, id, name }: IAction) => {
                if (attribute.actions && attribute.actions.length) {
                  attribute.actions.forEach((actionName: string) => {
                    if (actionName === name) attributeActionList.push({ key: id, displayName, name });
                  })
                }
              });
              const newAttribute = {
                attribute: {
                  key: attribute.attribute,
                  displayName: attribute.attribute,
                  name: attribute.attribute,
                  value: attribute.attribute,
                },
                attributeAction: attributeActionList
              }
              handleAddColumnAttribute(newAttribute);
            }
          })
        }
        if (dataPermissionArray && dataPermissionArray.length) {
          dataPermissionArray.forEach((dataPermission: any) => {
            const dataActionList: any = [];
            if (dataPermission) {
              resourceName[0]?.actions.forEach(({ displayName, id, name }: IAction) => {
                if (dataPermission.actions && dataPermission.actions.length) {
                  dataPermission.actions.forEach((actionName: string) => {
                    if (actionName === name) dataActionList.push({ key: id, displayName, name });
                  })
                }
              });
              const newDataPermission = {
                attribute: {
                  key: dataPermission?.condition?.attribute,
                  displayName: dataPermission?.condition?.attribute,
                  name: dataPermission?.condition?.attribute,
                  value: dataPermission?.condition?.attribute,
                },
                attributeAction: [],
                operator: {
                  key: dataPermission?.condition?.operator,
                  displayName: dataPermission?.condition?.operator
                },
                value: dataPermission?.condition?.values,
                valueAction: dataActionList
              }
              handleAddAttribute(newDataPermission);
            }
          })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceNS, resources, selectedNameSpace, namespaceVal]);

  const onEditEntityPolicySetData = async () => {
    if (edit && resourceNS.length) {
      const expression = JSON.parse(rowData.expression);
      const namespaceName = resourceNS.filter((item: IEnityResources) => item.name === expression?.namespace);
      await expandedItems(namespaceName[0]);
      dispatch(setPolicyEntitiesFormData("policyName", rowData.displayName));
      dispatch(setPolicyEntitiesFormData("policyDescription", rowData.description));
      dispatch(setPolicyEntitiesFormData("policyResource", expression?.resource?.name));
      dispatch(setPolicyEntitiesFormData(POLICY_NAMESPACE_ACTION, expression?.namespace));
      if (expression?.resource?.entitySecurity?.actions) {
        dispatch(setPolicyEntitiesFormData(POLICY_ENTITY_ACTION, expression?.resource?.entitySecurity?.actions));
      }
    }
  };

  const handleMultiSelectChange = (name: string, items: ISelect[]) => {
    dispatch(setPolicyEntitiesFormData(name, items));
    dispatch(updateEntityFormError(name, ''));
  };

  const handleOnChange = (e: { target: { name: string; value: string } }) => {
    dispatch(setPolicyEntitiesFormData(e.target.name, e.target.value));
    dispatch(updateEntityFormError(e.target.name, ''));
  };

  const handleEntityAttributes = async (childNode?: IEnityResources) => {
    const childNodeDataResource = childNode || childNodeData;
    if (childNodeDataResource) {
      const { id, name, namespaceId, typeId } = childNodeDataResource;
      const resourceType = typeId && await getResourceTypeById(namespaceId, typeId);

      if (selectedNameSpace.name === DATA_PLATFORM_NAMESPACE && resourceType?.name !== 'logical_entity') {
        getDPEntitiesAttributes(dispatch, name, version);
      } else {
        getEntitiesAttributes(dispatch, namespaceId, id, name);
      }
    }
  };

  const handleAddAttribute = (newDataPermission?: any) => {
    handleEntityAttributes();
    const attribute = {
      attribute: { key: 'select', displayName: 'Select' },
      attributeAction: [],
      operator: {
        key: 'equals',
        displayName: 'equals'
      },
      value: '',
      valueAction: []
    };
    if (newDataPermission?.attribute) {
      dispatch(addAttribute(newDataPermission));
    } else {
      dispatch(addAttribute(attribute));
    }
    dispatch(
      setAttributeFormErrorData([
        ...attributesFormError,
        {
          attribute: '',
          attributeAction: '',
          operator: {
            key: 'equals',
            displayName: 'equals'
          },
          value: '',
          valueAction: ''
        }
      ])
    );
  };

  const handleAddColumnAttribute = (newAttribute?: any) => {
    handleEntityAttributes();
    const attribute = {
      attribute: { key: 'select', displayName: 'Select' },
      attributeAction: []
    };
    if (newAttribute?.attribute) {
      dispatch(addColumnAttribute(newAttribute));
    } else {
      dispatch(addColumnAttribute(attribute))
    }
    dispatch(
      setColumnAttributeFormErrorData([
        ...columnAttributesFormError,
        {
          attribute: '',
          attributeAction: ''
        }
      ])
    );
  };

  const handleItemClick = (value: string, childNode: IEnityResources) => {
    const { actions, name } = childNode;
    if (namespaceVal !== value) {
      dispatch(resetEntityPolicyAttributes());
    }
    setChildNodeData(childNode);
    const actionList: any = actions.map(({ displayName, id, name }: IAction) => {
      return { key: id, displayName, name };
    });
    setNamespaceVal(value);
    if (!_.isEqual(resourceAction, actionList)) {
      dispatch(setPolicyEntitiesFormData(POLICY_ENTITY_ACTION, []));
    }
    setResourceAction(actionList);
    dispatch(setPolicyEntitiesFormData(POLICY_RESOURCE_ACTION, name));
    dispatch(updateEntityFormError(POLICY_RESOURCE_ACTION, ''));
    handleEntityAttributes(childNode);
  };

  const expandedItems = async (namespace: IEntityNameSpace) => {
    const { name } = namespace;
    setSelectedNameSpace(namespace);
    dispatch(setPolicyEntitiesFormData(POLICY_NAMESPACE_ACTION, name));
    dispatch(updateEntityFormError(POLICY_NAMESPACE_ACTION, ''));
    if (name === DATA_PLATFORM_NAMESPACE) {
      getDPModel(dispatch);
    }
  };

  const handleAutocompleteNamespace = async (_event: React.ChangeEvent<{}> | null, newValue: IEntityNameSpace | null) => {
    if (newValue) {
      await expandedItems(newValue)
      if (`${newValue.displayName}.${childNodeData.displayName}` !== namespaceVal) {
        setChildNodeData(null);
        dispatch(setResources([], {}));
        setResourceAction([]);
      }
    }
  };

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={5} className={classes.formStyle}>
        <TextField
          id="policyName"
          name={POLICY_NAME}
          variant="standard"
          label={POLICY_NAME_LABEL}
          className={classes.textFieldSpacing}
          fullWidth
          value={policyEntitiesFormData.policyName}
          onChange={handleOnChange}
          error={formErrorState.policyName !== ''}
          helperText={formErrorState.policyName}
          disabled={edit}
        />
      </Grid>
      <Grid item xs={6} className={classes.formStyle}>
        <TextField
          id="policyDescription"
          name={POLICY_DESCRIPTION}
          variant="standard"
          label={POLICY_DESC_LABEL}
          className={classes.textFieldSpacing}
          fullWidth
          value={policyEntitiesFormData.policyDescription}
          onChange={handleOnChange}
          error={formErrorState.policyDescription !== ''}
          helperText={formErrorState.policyDescription}
        />
      </Grid>
      <Grid item xs={12} className={classes.formStyle}>
        <Typography variant="h4" component="span" className={classes.attributeHeading}>
          <Box id="entity-title"  component="span">
            {ENTITY_TITLE}
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={4} className={classes.formStyle}>
        <Autocomplete
          value={selectedNameSpace}
          options={resourceNS ? resourceNS : []}
          getOptionLabel={(option: any) => option.displayName}
          onChange={handleAutocompleteNamespace}
          noOptionsText={NO_RECORDS_IN_SEARCH}
          disableClearable
          classes={{ option: classes.entityOptionItem }}
          renderInput={(params) =>
            <TextField
              {...params}
              label={NAMESPACE_LABEL}
              variant='standard'
              error={formErrorState.policyNamespace !== ''}
              helperText={formErrorState.policyNamespace}
              classes={{ root: classes.entityAutocompleteInput }}
            />
          }
        />
      </Grid>
      <Grid item xs={4} className={classes.formStyle}>
        <Box className={classes.searchBox}>
          <TextField
            id="policyResource"
            variant="standard"
            name="policyResource"
            label={POLICY_RESOURCE_LABEL}
            focused={openSearchResource}
            disabled={selectedNameSpace === defaultNameSpace}
            className={classes.textField}
            onBlur={handleClose}
            inputRef={textFieldRef}
            onFocus={() => { setOpenSearchResource(true) }}
            onChange={handleChange}
            InputProps={openSearchResource ? {
              endAdornment: <IconButton onClick={handleToggleSearch} size='small'><ArrowTrendUpFill color='action' fontSize='small' /></IconButton >
            } : {
              endAdornment: <IconButton data-testId="downArrow" disabled={selectedNameSpace === defaultNameSpace} onClick={handleToggleSearch} size='small'><ArrowTrendDownFill color='action' fontSize='small' /></IconButton>
            }
            }
            value={searchString}
          >
          </TextField>
          {openSearchResource &&
            <CustomSearchList
              pagination={pagination}
              list={resources}
              onSelectItem={onSelectResource}
              goToTheNextPage={handleGoToTheNextPage}
              selectedItem={selectedResource}
              onMouseDown={() => (ignoreBlurRef.current = true)}
              maxHeight={200}
            />
          }
        </Box>
      </Grid>
      <Grid item xs={3} className={classes.formStyle}>
        <LuiMultiSelectCustom
          id="action-multi-select"
          itemData={resourceAction.sort(compareByProperty(DISPLAY_NAME))}
          itemKey="key"
          disabled={resourceAction.length === 0}
          itemDisplayName={DISPLAY_NAME}
          inputLabel={POLICY_ACTIONS_LABEL}
          selectedItems={policyEntitiesFormData.policyAction}
          selectAll
          selectAllDisplayText={SELECT_ALL}
          classes={{ option: classes.entityOptionItem }}
          onSelectionChange={(e: any) => handleMultiSelectChange(POLICY_ENTITY_ACTION, e)}
          placeholder={POLICY_ACTIONS_LABEL}
          searchProps={{
            enableSearch: false,
            searchPlaceholder: 'Search',
          }}
          className={classes.entityOptionItem}
        />
        <FormHelperText id="policyAction-helper-text" error={formErrorState.policyAction !== ''}>
          {formErrorState.policyAction}
        </FormHelperText>
      </Grid>

      {errors.info ?
        <Alert icon={<Info />} elevation={0} severity={'info'} variant={'outlined'} style={{marginTop: 8}}>{errors.info}</Alert> :
        <>
          <Grid item xs={12} className={classes.formStyle}>
            <Typography variant="h4" component="span" className={classes.attributeHeading}>
              <Box id="column-attributes-title" component="span">
                {ENTITY_ATTRIBUTE_TITLE}
              </Box>
            </Typography>
            <Button
              name="add-column-attributes"
              disabled={
                policyEntitiesFormData.policyResource !== '' && policyEntitiesFormData.policyAction.length > 0
                  ? false
                  : true
              }
              onClick={handleAddColumnAttribute}
              variant="outlined"
              color="primary"
              size="small"
            >
              {ADD_ATTRIBUTE_BTN_TEXT}
            </Button>
          </Grid>
          <Grid item xs={12} className={classes.gridContainer}>
            {columnAttributes.map((attribute: any, i: number) => (
              <ColumnAttribute
                attribute={attribute}
                actions={resourceAction}
                key={i}
                index={i}
                entityName={policyEntitiesFormData.policyResource}
              />
            ))}
          </Grid>
          <Grid item xs={12} className={classes.formStyle}>
            <Typography variant="h4" component="span" className={classes.attributeHeading}>
              <Box id="attributes-title" component="span">
                {ENTITY_DATA_TITLE}
              </Box>
            </Typography>
            <Button
              name="add-attributes"
              disabled={
                policyEntitiesFormData.policyResource !== '' && policyEntitiesFormData.policyAction.length > 0
                  ? false
                  : true
              }
              onClick={handleAddAttribute}
              variant="outlined"
              color="primary"
              size="small"
            >
              {ADD_ATTRIBUTE_BTN_TEXT}
            </Button>
          </Grid>
          <Grid item xs={12} className={classes.gridContainer}>
            {attributes.map((attribute: any, i: number) => (
              <Attribute
                attribute={attribute}
                key={i}
                edit={edit}
                index={i}
                actions={resourceAction}
                entityName={policyEntitiesFormData.policyResource}
              />
            ))}
          </Grid>
        </>
      }
      {errors && <ErrorMessage message={errors.message} />}
    </Grid>
  );
};

export default Entities;
